import { FLAG_ENVIRONMENTS } from './flag';

import type { FlagEnvironment } from './flag';

/**
 * How a backend environment renders.
 *
 * Its own module rather than a constant exported from a component, same reason
 * as `lifecycle.ts`: a file that exports both components and values loses Fast
 * Refresh for everything in it.
 */

export const ENVIRONMENT_LABEL: Record<FlagEnvironment, string> = {
    dev: 'Dev',
    stg: 'Staging',
    prd: 'Production',
    eph: 'Ephemeral',
};

/**
 * One line of what each partition actually covers — shown as a hint next to
 * the column header, since `eph` in particular is easy to misread as "one
 * ephemeral stage" rather than the collective partition it is. See the API's
 * `domain/flag-environment.ts` for why.
 */
export const ENVIRONMENT_DESCRIPTION: Record<FlagEnvironment, string> = {
    dev: 'The dev account.',
    stg: 'The staging account.',
    prd: 'The production account — the widest blast radius short of the platform default.',
    eph: 'Every ephemeral review stage, collectively. Not addressable one stage at a time.',
};

/** Display order for the matrix columns — the same order the API enumerates them in. */
export const ENVIRONMENT_ORDER: readonly FlagEnvironment[] = FLAG_ENVIRONMENTS;
